import { Component } from "react";
import Icon from "./Icon";

// Tras un deploy, un chunk lazy referenciado por el bundle viejo ya no existe
// en el servidor (se borró al subir el build nuevo) — React re-lanza ese
// rechazo de import() al ErrorBoundary más cercano. En vez de mostrar la
// pantalla de error, recargamos una sola vez (la recarga trae index.html
// fresco con las rutas de chunk correctas). Si tras recargar sigue fallando
// (problema real, no de versión), la marca ya está puesta y se muestra el
// error normal — evita el loop de recargas infinito.
const CHUNK_ERROR_RE = /dynamically imported module|Importing a module script failed|Failed to fetch dynamically imported/i;
const RELOAD_GUARD_KEY = "tf-chunk-reload";

/**
 * Catches any render error below it so a single broken component shows a
 * readable message instead of blanking the whole app (React unmounts the entire
 * tree on an uncaught render error). Without this, any page bug = white screen.
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // Surface for support: shows up in the browser console / server logs.
    console.error("UI crash:", error, info?.componentStack);
    const message = String(error?.message || error);
    if (CHUNK_ERROR_RE.test(message) && !sessionStorage.getItem(RELOAD_GUARD_KEY)) {
      sessionStorage.setItem(RELOAD_GUARD_KEY, "1");
      window.location.reload();
    }
  }

  render() {
    const { error } = this.state;
    if (!error) return this.props.children;
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6">
        <div className="card w-full max-w-lg p-6 text-center">
          <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-rose-100 text-rose-600">
            <Icon name="alert" size={24} />
          </div>
          <h1 className="text-lg font-bold text-slate-800">Se produjo un error en la página</h1>
          <p className="mt-1 text-sm text-slate-500">
            La aplicación sigue activa. Recarga la página; si el problema continúa, comparte este detalle con soporte.
          </p>
          <pre className="mt-3 max-h-40 overflow-auto rounded-lg bg-slate-100 p-3 text-left text-[11px] text-rose-700">
            {String(error?.message || error)}
          </pre>
          <div className="mt-4 flex justify-center gap-2">
            <button className="btn-primary" onClick={() => window.location.reload()}>
              Recargar
            </button>
            <button className="btn-ghost" onClick={() => window.location.assign("/")}>
              Volver al inicio
            </button>
          </div>
        </div>
      </div>
    );
  }
}
